const G = "#83B68B", D = "#0F172A", W = "#FFFFFF", SKIN = "#F2C9A0", DARKG = "#5E8F66";

const Arm = ({ wave }) => (
  <g className={wave ? "ernie-wave" : ""}>
    <path d="M49 42 L58 27" stroke={G} strokeWidth="5.5" strokeLinecap="round" />
    <circle cx="59" cy="25" r="4.5" fill={SKIN} />
  </g>
);

const FlatCap = ({ wave }) => (
  <>
    <circle cx="32" cy="32" r="30" fill={D} />
    <Arm wave={wave} />
    {/* Elsenham shirt: green with white collar + dark trim */}
    <path d="M13 64 Q13 46 32 46 Q51 46 51 64 Z" fill={G} />
    <path d="M13 64 L13 52 Q15 47 20 46 L24 46 L20 64 Z M51 64 L51 52 Q49 47 44 46 L40 46 L44 64 Z" fill={DARKG} opacity="0.55" />
    <path d="M25 46 L32 54 L39 46 L36.5 45 L32 50 L27.5 45 Z" fill={W} />
    <circle cx="41" cy="55" r="3.2" fill={D} stroke={W} strokeWidth="1" />
    {/* neck + face */}
    <rect x="28" y="40" width="8" height="8" fill={SKIN} />
    <ellipse cx="32" cy="31" rx="13.5" ry="14.5" fill={SKIN} />
    {/* grey sideburns / hair */}
    <path d="M18.5 30 Q17 40 21 42 L22 30 Z M45.5 30 Q47 40 43 42 L42 30 Z" fill="#CBD5E1" />
    {/* ears */}
    <ellipse cx="18.5" cy="31" rx="2.6" ry="3.5" fill={SKIN} />
    <ellipse cx="45.5" cy="31" rx="2.6" ry="3.5" fill={SKIN} />
    {/* flat cap (tweed) */}
    <path d="M17 26 Q18 12 32 11 Q46 12 47 26 Z" fill="#6B5B45" />
    <path d="M22 18 Q32 14 42 18" stroke="#8A7A62" strokeWidth="1.2" fill="none" opacity="0.7" />
    <path d="M27 14 Q32 12.5 37 14" stroke="#8A7A62" strokeWidth="1.2" fill="none" opacity="0.7" />
    <path d="M16 26 Q32 22 50 27 Q48 30 44 29 L17 29 Z" fill="#4E4233" />
    {/* bushy grey eyebrows */}
    <path d="M23 29.5 Q27 27 30 29" stroke="#CBD5E1" strokeWidth="2.6" strokeLinecap="round" />
    <path d="M34 29 Q37 27 41 29.5" stroke="#CBD5E1" strokeWidth="2.6" strokeLinecap="round" />
    {/* eyes with crow's feet */}
    <circle cx="26.5" cy="33" r="1.8" fill={D} />
    <circle cx="37.5" cy="33" r="1.8" fill={D} />
    <path d="M21.5 32 L23 33 M21.5 35 L23 34 M42.5 32 L41 33 M42.5 35 L41 34" stroke="#C9976A" strokeWidth="0.9" />
    {/* rosy cheeks */}
    <circle cx="24" cy="37.5" r="2.2" fill="#E9A48A" opacity="0.55" />
    <circle cx="40" cy="37.5" r="2.2" fill="#E9A48A" opacity="0.55" />
    {/* moustache + smile */}
    <path d="M26 40 Q32 37 38 40 Q35 40.5 32 39.5 Q29 40.5 26 40 Z" fill="#CBD5E1" />
    <path d="M27.5 42 Q32 45.5 36.5 42" stroke="#9B5A45" strokeWidth="1.6" fill="none" strokeLinecap="round" />
  </>
);

const Coach = ({ wave }) => (
  <>
    <circle cx="32" cy="32" r="30" fill={D} />
    <Arm wave={wave} />
    <path d="M14 64 Q14 46 32 46 Q50 46 50 64 Z" fill={G} />
    <path d="M27 47 L32 53 L37 47" fill={W} opacity="0.9" />
    <circle cx="32" cy="30" r="15" fill={SKIN} />
    <path d="M16 28 Q32 8 48 28 L48 30 L16 30 Z" fill={G} />
    <rect x="14" y="27" width="36" height="4" rx="2" fill={DARKG} />
    <path d="M48 29 L57 33 L48 33 Z" fill={DARKG} />
    <circle cx="27" cy="33" r="1.9" fill={D} />
    <circle cx="37" cy="33" r="1.9" fill={D} />
    <path d="M26 39 Q32 44 38 39" stroke={D} strokeWidth="1.8" fill="none" strokeLinecap="round" />
    <circle cx="41" cy="50" r="3" fill={W} stroke={D} strokeWidth="1" />
  </>
);

const Owl = ({ wave }) => (
  <>
    <circle cx="32" cy="32" r="30" fill={D} />
    <g className={wave ? "ernie-wave" : ""}>
      <path d="M50 44 L59 30" stroke="#8B5E3C" strokeWidth="6" strokeLinecap="round" />
    </g>
    <ellipse cx="32" cy="40" rx="19" ry="21" fill="#8B5E3C" />
    <ellipse cx="32" cy="44" rx="11" ry="13" fill="#D9A46F" />
    <path d="M15 24 L20 12 L27 22 Z M49 24 L44 12 L37 22 Z" fill="#8B5E3C" />
    <circle cx="24" cy="30" r="8" fill={W} />
    <circle cx="40" cy="30" r="8" fill={W} />
    <circle cx="25" cy="31" r="3.6" fill={D} />
    <circle cx="39" cy="31" r="3.6" fill={D} />
    <circle cx="26" cy="30" r="1.1" fill={W} />
    <circle cx="40" cy="30" r="1.1" fill={W} />
    <path d="M29 38 L32 43 L35 38 Z" fill="#E8913A" />
    <path d="M13 50 Q32 44 51 50 L51 56 Q32 50 13 56 Z" fill={G} />
    <path d="M13 56 L18 63 L22 56 Z" fill={G} />
  </>
);

const Lion = ({ wave }) => (
  <>
    <circle cx="32" cy="32" r="30" fill={D} />
    <g className={wave ? "ernie-wave" : ""}>
      <path d="M50 44 L59 30" stroke="#E0A040" strokeWidth="6" strokeLinecap="round" />
    </g>
    <circle cx="32" cy="34" r="24" fill="#C8702A" />
    {[0,45,90,135,180,225,270,315].map(a => (
      <ellipse key={a} cx="32" cy="10" rx="5" ry="8" fill="#A85A1E" transform={`rotate(${a} 32 34)`} />
    ))}
    <circle cx="32" cy="34" r="16" fill="#E0A040" />
    <ellipse cx="32" cy="41" rx="8" ry="6" fill="#F4D9A8" />
    <circle cx="26" cy="31" r="2" fill={D} />
    <circle cx="38" cy="31" r="2" fill={D} />
    <path d="M29 38 L32 41 L35 38 Z" fill={D} />
    <path d="M32 41 Q29 45 26 43 M32 41 Q35 45 38 43" stroke={D} strokeWidth="1.4" fill="none" strokeLinecap="round" />
    <path d="M12 54 Q32 48 52 54 L52 60 Q32 54 12 60 Z" fill={G} />
  </>
);

const Robot = ({ wave }) => (
  <>
    <circle cx="32" cy="32" r="30" fill={D} />
    <Arm wave={wave} />
    <line x1="32" y1="8" x2="32" y2="15" stroke={G} strokeWidth="2.5" />
    <circle cx="32" cy="7" r="3" fill={G} />
    <rect x="14" y="15" width="36" height="30" rx="9" fill="#E8EEF4" />
    <rect x="18" y="20" width="28" height="15" rx="6" fill={D} />
    <circle cx="26" cy="27.5" r="3.2" fill={G} />
    <circle cx="38" cy="27.5" r="3.2" fill={G} />
    <path d="M25 40 Q32 44 39 40" stroke={D} strokeWidth="2" fill="none" strokeLinecap="round" />
    <rect x="10" y="26" width="4" height="8" rx="2" fill={G} />
    <rect x="50" y="26" width="4" height="8" rx="2" fill={G} />
    <path d="M16 64 Q16 48 32 48 Q48 48 48 64 Z" fill={G} />
    <circle cx="32" cy="55" r="2.5" fill={W} opacity="0.8" />
  </>
);

const VARIANTS = { flatcap: FlatCap, coach: Coach, owl: Owl, lion: Lion, robot: Robot };
export const ERNIE_VARIANTS = Object.keys(VARIANTS);

export const ErnieAvatar = ({ size = 40, wave = false, className = "", variant = "flatcap" }) => {
  const Body = VARIANTS[variant] || FlatCap;
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label="Ernie"
      className={`${wave ? "ernie-bounce" : ""} ${className}`} data-testid="ernie-avatar" style={{ borderRadius: "50%", overflow: "hidden" }}>
      <Body wave={wave} />
    </svg>
  );
};
